(() => {
  if (customElements.get('pe-buy-now')) return;
  class PeBuyNow extends HTMLElement {
    connectedCallback() {
      this.form = this.closest('form');
      this.link = this.querySelector('a');
      if (!this.form || !this.link) return;
      this.controller = new AbortController();
      this.root = this.closest('product-info') || this.closest('.product__info-container') || this.form;
      this.submitButton = this.form.querySelector('button[name="add"]');
      const signal = this.controller.signal;
      this.sync = () => {
        const variant = this.form.elements.namedItem('id');
        const quantity = this.form.elements.namedItem('quantity');
        const amount = quantity ? Number(quantity.value) : 1;
        const valid = variant && /^\d+$/.test(variant.value) && !variant.disabled && !this.submitButton?.disabled &&
          Number.isInteger(amount) && amount > 0 && (!quantity || quantity.checkValidity());
        this.link.setAttribute('aria-disabled', String(!valid));
        if (!valid) {
          this.link.removeAttribute('href');
          this.link.setAttribute('tabindex', '-1');
          return;
        }
        const url = new URL(this.dataset.cartUrl.replace(/\/$/, '') + '/' + variant.value + ':' + amount, document.baseURI);
        const properties = {};
        for (const [name, value] of new FormData(this.form)) {
          const match = name.match(/^properties\[(.+)\]$/);
          if (match && typeof value === 'string' && value) properties[match[1]] = value;
        }
        if (Object.keys(properties).length) {
          const bytes = new TextEncoder().encode(JSON.stringify(properties));
          const encoded = btoa(Array.from(bytes, byte => String.fromCharCode(byte)).join(''));
          url.searchParams.set('properties', encoded.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, ''));
        }
        this.link.href = url.href;
        this.link.removeAttribute('tabindex');
      };
      this.root.addEventListener('change', this.sync, { signal });
      this.root.addEventListener('input', this.sync, { signal });
      this.link.addEventListener('click', event => {
        this.sync();
        if (this.link.getAttribute('aria-disabled') === 'true') event.preventDefault();
      }, { signal });
      if (this.submitButton) {
        this.observer = new MutationObserver(this.sync);
        this.observer.observe(this.submitButton, { attributes: true, attributeFilter: ['disabled'] });
      }
      this.sync();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
    }
  }
  customElements.define('pe-buy-now', PeBuyNow);
})();
